<template>
	<div class="page-content page-kyaneos-1">
		<kyaneos-header />

		<div class="tle-row condensed">
			<div class="tle-col two-third">
				<h1 class="k-h1 text-center">Rapport d'expertise</h1>
				<div class="text-bold">
					Code : {{ active_project.customGeoDetails.kyaneos.Code }}<br/>
					Adresse : <el-textarea :parent_data="active_study.etudeData" property="titre" :editable="true" inline /><br/>
					Code postal et ville : <el-textarea  :parent_data="active_project.adresse" property="codePostal" :editable="false" inline /> <el-textarea  :parent_data="active_project.adresse" property="ville" :editable="false" inline />
					
				</div>
				<div>
					<h2 class="k-h2">Mission</h2>
					<div class="tle-row">
						<div class="tle-col half">
							<h3 class="k-h3 q-mt-none">
								Adresse du client
							</h3>
						</div>
						<div class="tle-col half">
							SCPI KYANEOS <el-textarea :parent_data="active_study.etudeData.scpi.garde" property="clientFirm" :editable="true" inline /><br/>
							Avenue de la 2ème DB<br/>
							Immeuble Grand Angles<br/>
							30133 Les Angles
						</div>
					</div>
				</div>
			</div>
			<div class="tle-col one-third">
				<el-image
					:parent_data="active_study.etudeData.scpi.garde.images[0]"
					property="src"
					:editable="true"
					max_height="150px"
					edition_position="right"
				/>
				<el-textarea
					:parent_data="active_study.etudeData.scpi.garde.images[0]"
					property="description"
					:editable="true"
					class="text-center text-italic image-description"
				/>
			</div>
		</div>

		<div class="q-mt-lg">
			<h3 class="k-h3">Rappel des conditions d’intervention</h3>

			<p>
				La présente mission a été réalisée dans les conditions définies par le contrat signé avec la <el-textarea :parent_data="active_study.etudeData.scpi.garde" property="company_name" :editable="true" inline />; conformément à cette instruction, nous avons le plaisir de vous soumettre notre rapport concernant un actif situé : {{  active_study.nom }}
			</p>
			
			<h3 class="k-h3">Hypothèse d’évaluation</h3>
			<p>
				À la demande de notre mandante, nous retiendrons l’hypothèse de valorisation suivante : Estimation des biens en poursuite d’usage compte tenu de leur état d’occupation.
			</p>
			<h3 class="k-h3">Date de valeur</h3>
			<p>
				La date de valeur considérée est le <el-textarea :parent_data="active_study.etudeData.scpi.garde" property="date_valeur" :editable="true" inline /> <br/>
				Les conclusions de notre rapport sont sous réserve d’absence de modifications notables portant sur les données du marché immobilier, de l’état d’occupation, ou de tout autre élément susceptible d’impacter la valorisation des biens étudiés, qui pourrait survenir entre la date du présent rapport et la date de valeur.
			</p>
			<h3 class="k-h3">Référentiels</h3>
			<p>
				Les estimations réalisées sont conformes aux normes professionnelles applicables en la matière, soit celle de la RICS (Red Book), des EVS (European Valuation Standards) et de la Charte de l’Expertise en Evaluation Immobilière.
			</p>
			<h3 class="k-h3">Visite</h3>
			<p>
				Une visite est intervenue le <el-textarea :parent_data="active_study.etudeData.scpi.garde" property="date_visite" :editable="true" inline />
			</p>
		</div>

		<div>
			<h2 class="k-h2">
				Désignation
			</h2>
			<div class="q-mb-sm">
				<h3 class="k-h3 k-inline">Désignation</h3> :
				<p class="k-inline">
					Sur la commune de <el-textarea :parent_data="active_study.etudeData.scpi.garde" property="designation_adresse" :editable="true" inline />
				</p>
			</div>
			<el-textarea :parent_data="active_study.etudeData.scpi.garde" property="designation" :editable="true" />
			<h3 class="k-h3">Cadastre</h3>
			<div class="q-mb-lg q-mt-md q-mx-xl">
				<el-table
					:table="table_cadastres"
					:lines-obj="active_study.etudeData.scpi.garde"
					lines-field="cadastres_lignes"
					lines-box-class="left lefter"
					nb-lines-max="3"
				/>
			</div>
			<div class="q-mb-sm">
				<h3 class="k-h3 k-inline">Situation juridique</h3> :
				<p class="k-inline">
					<el-textarea :parent_data="active_study.etudeData.scpi.garde" property="situation_juridique" :editable="true" inline />
				</p>
			</div>
			<div class="q-mb-sm">
				<h3 class="k-h3 k-inline">Nature</h3> :
				<p class="k-inline">
					Ensemble immobilier bâti
				</p>
			</div>
			<div class="q-mb-sm">
				<h3 class="k-h3 k-inline">Affectation juridique</h3> :
				<p class="k-inline">
					Les locaux ont la qualification juridique
					<el-textarea :parent_data="active_study.etudeData.scpi.garde" property="affectation_juridique" :editable="true" inline />
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";

export default {
	components: { KyaneosHeader },
	name: "page-kyaneos-1",
	mixins: [ PageMixin ],
	props: [ "index" ],
	watch: {
		active_study: {
			// ce watcher permet de gérer les études créées avant
			// l'ajout de la propriété situation_juridique dans le
			// template des études. Il permet de mettre la valeur
			// par défaut manuellement (valeur définie normalement
			// dans `etude_data_template.js`)
			handler (value) {
				if (value){
					if (this.active_study.etudeData.scpi.garde.situation_juridique == undefined){
						this.active_study.etudeData.scpi.garde.situation_juridique = "Pleine propriété";
					}
				}
			},
			immediate: true
		}
	},
	computed: {
		...mapGetters([ "active_project", "active_study" ]),
		table_cadastres: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [40, 30, 30],
				},
			};

			table.head.push(["Références cadastrales", "Lieudit", "Contenance"]);

			for (let i = 0; i < this.active_study.etudeData.scpi.garde.cadastres_lignes; i++) {
				const loc = this.active_study.etudeData.scpi.garde.cadastres[i];

				const rows = [
					{
						parent_data: loc,
						property: "reference",
						editable: true,
					},
					{
						parent_data: loc,
						property: "lieudit",
						editable: true,
					},
					{
						parent_data: loc,
						property: "contenance",
						editable: true,
						suffix: "m²",
					},
				];

				table.body.push(rows);
			}

			return table;
		},
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'
</style>